
<div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-bg-gray-100" *ngIf="loading">
  <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
</div>
<section class="tw-flex tw-flex-col tw-h-full" *ngIf="!loading">
  <section class="tw-bg-black">
    <section class="tw-pt-[13px] tw-pb-[11px] tw-px-6 tw-mb-[10px]">
      <div class="tw-absolute tw-left-[34px] tw-top-3" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
      </div>
      <p class="tw-font-body tw-text-white tw-text-400 tw-w-max tw-m-auto" i18n="@@chooseTreatmentPlan">Choose treatment plan</p>
    </section>
  </section>
  <section class="tw-w-full tw-h-full tw-bg-teal-100">
    <section class="tw-w-full">
      <p class="tw-font-lexend tw-font-semibold tw-text-gray-800 tw-pt-3 tw-pl-4" i18n="@@yourTreatmentPlanIncludes">Your&nbsp;<span>₹{{regimen.totalSP}}</span>&nbsp;treatment plan includes</p>
      <section class="tw-p-4 tw-pr-7 tw-bg-white tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mx-4 tw-my-2 tw-shadow-z4 tw-rounded-2" *ngFor="let item of planInfoConfig['advance'].items; let i = index;">
        @if (item.id === planInfoItemId.DEDICATED_DOCTOR || item.id === planInfoItemId.ONE_ON_ONE_DOCTOR) {
          <div class="tw-w-16 tw-h-16 tw-rounded-full tw-overflow-hidden tw-bg-gray-100 tw-flex tw-items-end tw-justify-center">
            <img class="tw-flex-none tw-block tw-w-[48px] tw-h-[58px] tw-rounded-full" [src]="getItemImage(item, i)" alt="doctorThumbnail"/>
          </div>
        } @else {
          <img class="tw-flex-none tw-block tw-w-16 tw-h-16 tw-rounded-full" [src]="getItemImage(item, i)" alt="item"/>
        }
        <div class="tw-flex-1">
          @if (item.id === planInfoItemId.PRODUCTS) {
            <h2 class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-900 tw-mb-0.5">
              <span i18n="@@PRODUCT_TREATMENT_KIT_WITH_COUNT">{{ regimen?.products?.length || 4 }} product Treatment Kit</span>
            </h2>
            <p class="tw-font-body tw-text-200 tw-text-gray-500">
              @if (regimen?.class === appConfig.Shared.Regimen.Class.HAIR) {
                <span i18n="@@CUSTOMISED_KIT_PRODUCTS_WITH_COUNT_HAIR">A customised kit of {{ regimen?.products?.length || 4 }} products for your hair concerns.</span>
              } @else {
                <span i18n="@@CUSTOMISED_KIT_PRODUCTS_WITH_COUNT">A customised kit of {{ regimen?.products?.length || 4 }} products for your skin concerns.</span>
              }
            </p>
          } @else {
            <h2 class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-900 tw-mb-0.5">
              {{ item.title }}
            </h2>
            <p class="tw-font-body tw-text-200 tw-text-gray-500">
              {{ item.description }}
            </p>
          }
        </div>
      </section>
    </section>
    <div class="tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-text-black tw-mt-2 tw-mx-4 tw-py-2 tw-px-[9px]">
      <p class="tw-w-[98px] tw-text-left" i18n="@@100%Effective">100% Effective</p>
      <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
      <p class="tw-flex-1 tw-text-center" i18n="@@clinicallyTested">Clinically Tested</p>
      <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
      <p class="tw-w-[90px] tw-text-right" i18n="@@freeDelivery">Free Delivery</p>
    </div>
  </section>

  <div class="tw-p-4 tw-pb-6">
    <button class="tw-border-none tw-w-full tw-h-[54px] tw-relative tw-text-[#ffffff] tw-text-[18px] tw-capitalize tw-p-4 shine loop tw-bg-teal-600 tw-overflow-visible tw-mb-2 tw-rounded-3"
            (click)="buyRegimen()">
        <div class="tw-absolute tw-flex tw-items-center tw-justify-center tw-top-[-15px] tw-left-[10px] tw-text-orange-400">
          <svg class="tw-w-[85px] tw-h-[85px] tw-relative tw-animate-spin_slow"
               xmlns="http://www.w3.org/2000/svg"
               width="64.443"
               height="67.447"
               viewBox="0 0 64.443 67.447">
            <path id="Path_23051"
                  data-name="Path 23051"
                  d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                  transform="translate(-23.961 -186.363)"
                  fill="#D66736"></path>
          </svg>
          <span
                class="tw-absolute tw-font-body tw-text-650 tw-text-white tw-z-20 tw-font-bold tw-leading-none">{{regimen.discount}}%
            <br />Off </span>
        </div>
        <span class="tw-ml-20 tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]">
          <span [ngStyle]="{ 'font-size': user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'ml' ? '12px' : '18px' }"
                i18n="@@buyNow">Buy Now</span>
          <span> &#64;</span>
          <span class="tw-text-200  tw-line-through">₹{{regimen.totalMRP}}</span>
          <span>₹{{regimen.totalSP}}</span>
        </span>
      </button>
  </div>
</section>
